import React, { useState, useEffect } from "react";
import { Input, Select, DatePicker, AutoComplete } from "antd";
import moment from "moment";

export default function DateConfigSelect(props) {
  const [dateOption, setDateOption] = useState("daysBefore");
  const [timeUnits, setTimeUnits] = useState(1);
  const [fixedDate, setFixedDate] = useState(null);
  const [dateFormat, setDateFormat] = useState("YYYY-MM-DDTHH:mm:ss.SS[Z]");

  const { showError, errorMessage } = props;

  useEffect(() => {
    if (props.dateConfig) {
      setDateOption(props.dateConfig.dateOption);
      setTimeUnits(props.dateConfig.timeUnits);
      setFixedDate(props.dateConfig.fixedDate ? moment(props.dateConfig.fixedDate) : null);
      setDateFormat(props.dateConfig.dateFormat);
    }
  }, [props.dateConfig]);

  const dateFormatOptions = [
    { value: "YYYY-MM-DD" },
    { value: "YYYY-MM-DDTHH:mm:ss.SS[Z]" },
    { value: "YYYY-MM-DDThh:mm:ss.Z" },
  ];

  const handleStDateOption = (val) => {
    setDateOption(val);

    if (props.onClearError) props.onClearError();

    // Reset fixedDate and timeUnits to initial state when changing option
    const resetFixedDate = null;
    const resetTimeUnits = 1;

    setFixedDate(resetFixedDate);
    setTimeUnits(resetTimeUnits);

    // For "today" option, send the current date formatted
    let dateValue = null;
    if (val === "today") {
      dateValue = moment().format(dateFormat);
    }

    props.handleSetDateOptions({
      dateOption: val,
      timeUnits: resetTimeUnits,
      fixedDate: dateValue, // Will be null for non-today options, current date for today
      dateFormat: dateFormat,
    });
  };

  const handleSetTimeUnits = (e) => {
    let units = Number(e.target.value);
    if (units < 1) units = 1;
    setTimeUnits(units);
    props.handleSetDateOptions({
      dateOption: dateOption,
      timeUnits: units,
      fixedDate: dateOption === "today" ? moment().format(dateFormat) : fixedDate ? fixedDate.format(dateFormat) : null,
      dateFormat: dateFormat,
    });
  };

  const handleSetFixedDate = (e) => {
    setFixedDate(e);

    if (props.onClearError) props.onClearError();
    props.handleSetDateOptions({
      dateOption: dateOption,
      timeUnits: timeUnits,
      fixedDate: e ? e.format(dateFormat) : null,
      dateFormat: dateFormat,
    });
  };

  const handleDateFormatChange = (e) => {
    setDateFormat(e);

    // Recalculate date value based on current option
    let dateValue = null;
    if (dateOption === "today") {
      dateValue = moment().format(e);
    } else if (dateOption === "fixedDate" && fixedDate) {
      dateValue = fixedDate.format(e);
    }

    props.handleSetDateOptions({
      dateOption: dateOption,
      timeUnits: timeUnits,
      fixedDate: dateValue,
      dateFormat: e,
    });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        gap: "5px",
        alignItems: "center",
        marginBottom: "8px",
        marginTop: "8px",
      }}
    >
      <Select
        style={{ width: "30%" }}
        placeholder="Settings"
        onChange={(val) => handleStDateOption(val)}
        value={dateOption}
        getPopupContainer={() => document.getElementById("rest-api-modal-content")}
        disabled={props.isViewOnly}
      >
        <Select.Option value="fixedDate">Fixed Date</Select.Option>
        <Select.Option value="today">Today</Select.Option>
        <Select.Option value="daysBefore">Days Before</Select.Option>
      </Select>
      <>
        {(() => {
          switch (dateOption) {
            case "fixedDate":
              return (
                <div style={{ width: "30%" }}>
                  <DatePicker
                    style={{
                      width: "100%",
                      borderColor: showError ? "#ff4d4f" : undefined,

                      borderWidth: showError ? 1 : undefined,
                    }}
                    getPopupContainer={() => document.getElementById("rest-api-modal-content")}
                    format={dateFormat}
                    onChange={handleSetFixedDate}
                    value={fixedDate}
                    disabled={props.isViewOnly}
                    status={showError ? "error" : ""}
                    inputReadOnly
                  />
                  {showError && (
                    <div style={{ color: "#ff4d4f", fontSize: "12px", marginBottom: "-18px" }}>{errorMessage}</div>
                  )}
                </div>
              );
            case "daysBefore":
              return (
                <div style={{ width: "30%" }}>
                  <Input
                    type="number"
                    style={{ width: "100%" }}
                    onChange={handleSetTimeUnits}
                    value={timeUnits}
                    disabled={props.isViewOnly}
                    min={1}
                  />
                  {showError && (
                    <div style={{ color: "#ff4d4f", fontSize: "12px", marginTop: "4px" }}>{errorMessage}</div>
                  )}
                </div>
              );
            case "today":
              return (
                <div style={{ width: "30%" }}>
                  <Input
                    style={{ width: "100%" }}
                    value={moment().format(dateFormat)}
                    disabled={true}
                    placeholder="Current date"
                  />
                </div>
              );
            default:
              return null;
          }
        })()}
      </>
      <Select
        value={dateFormat}
        style={{ width: "40%" }}
        placeholder="Date Format"
        options={dateFormatOptions}
        onChange={handleDateFormatChange}
        disabled={props.isViewOnly}
        showSearch={false}
        getPopupContainer={() => document.getElementById("rest-api-modal-content")}
      />
    </div>
  );
}
